import styled from "styled-components"

export const ErrorMessage = styled.p`
  text-align: center;
  color: var(--pink);
  margin-top: 12px;
`